import { Component, OnInit, ViewChild, QueryList, ViewChildren, ElementRef, Optional, Inject, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { MedicineModal } from 'app/EMR/DoctorModels/medicine.model';
import { EMRService } from 'app/EMR/EMR.service';
import { MedicineTemplateComponent } from 'app/EMR/template_help/medicine-template/medicine-template.component';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { fromEvent, interval, Observable, of, Subject } from 'rxjs';
import { take, exhaustMap, tap, takeUntil } from 'rxjs/operators';
import { DynamicHelpListComponent } from '../doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { VoiceRecognitionService } from 'app/masters/service/voice-recognition.service';
import * as moment from 'moment';
import { AuthService } from 'app/auth/auth.service';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-medicine',
  templateUrl: './medicine.component.html',
  styleUrls: ['./medicine.component.scss']
})
export class MedicineComponent implements OnInit {
  destroymedicine$: Subject<boolean> = new Subject<boolean>();
  private mediniceMainArray: any = [];
  private medicine_dss: MatTableDataSource<MedicineModal>
  private dosedataArray: any = [];
  // presRemarksArray: any = [];
  private sitelist: any = [];
  private searchValue02: any;
  private examid: any;
  private examdetailArray: any = [];
  private viewdescbutton: boolean = false;
  private medicinlistarray: any = [];
  private showspinner: boolean = false;
  isheader: boolean = false
  // emrservice.enabledisablebtnMed:boolean=false;

  /** Append AI-scribed medicine rows (from voice) into the prescription grid as
   *  editable draft rows. The doctor still saves explicitly. */
  /** AI Scribe: pull medicines from the pending workup into this grid, then clear. */
  consumeAiMedicines(): void {
    const p = this.emrservice.aiWorkupPending;
    if (!p || !p.medicines || !p.medicines.length) { return; }
    const shown = (this.medicine_dss && this.medicine_dss.data) || [];
    if (shown.some((r: any) => r && r.aiSuggested)) { return; }   // already applied
    this.applyAiMedicines(p.medicines);   // do NOT clear — allow re-apply after reloads
  }

  applyAiMedicines(rows: any[]): void {
    if (!rows || !rows.length) { return; }
    this.mediniceMainArray = (this.medicine_dss && this.medicine_dss.data) ? this.medicine_dss.data.slice() : [];
    const refresh = () => { this.medicine_dss = new MatTableDataSource(this.mediniceMainArray.slice()); };

    rows.forEach((r) => {
      const dose = (this.dosedataArray || []).find((d: any) => (d.dosageCode || '') === (r.dosageCode || ''));
      const idx = this.mediniceMainArray.push({
        pK_TranId: 0, fK_ExamId: 0, medicineName: r.medicineName || '',
        qty: r.qty || null, unitQty: null, dosageCode: r.dosageCode || '',
        days: r.days || '', daysUnit: r.daysUnit || 'D', site: r.site || '',
        remarks: r.remarks || '', fK_DosageId: dose ? dose.pK_DosageId : 0,
        pK_MedicineId: 0, isEdit: false, aiSuggested: true, aiUnmatched: true,
      }) - 1;

      // resolve the medicine name -> master id (async), then update that row
      if (r.medicineName) {
        this.emrservice.GetMedicineMaster(0, r.medicineName, 'A', 0)
          .pipe(takeUntil(this.destroymedicine$))
          .subscribe((data: any[]) => {
            const list = (data || []).filter((x: any) => x.isActive);
            const hit = this.matchByName(list, r.medicineName, 'medicineName');
            if (hit) {
              const row = this.mediniceMainArray[idx];
              row.pK_MedicineId = hit.pK_MedicineId;
              row.medicineName = hit.medicineName;
              // copy secondary dropdown ids from the matched master (route/category/mfg/type/unit)
              if (hit.fK_RouteId) { row.fK_RouteId = hit.fK_RouteId; }
              if (hit.routeName || hit.route) { row.route = hit.routeName || hit.route; }
              if (hit.fK_CategoryId) { row.fK_CategoryId = hit.fK_CategoryId; }
              if (hit.fK_MfgId) { row.fK_MfgId = hit.fK_MfgId; }
              if (hit.fK_TypeId) { row.fK_TypeId = hit.fK_TypeId; }
              if (hit.medicineType) { row.medicineType = hit.medicineType; }
              if (hit.medicineCategory) { row.medicineCategory = hit.medicineCategory; }
              if (hit.manufacturerName) { row.manufacturerName = hit.manufacturerName; }
              if (!row.qtyUnit && (hit.qtyUnit || hit.unitQty)) { row.qtyUnit = hit.qtyUnit || hit.unitQty; }
              row.aiUnmatched = false;
              refresh();
            }
          }, () => { /* keep name-only on error */ });
      }
    });
    refresh();
  }

  /** Best-effort name match against a master list (exact, then contains). */
  private matchByName(list: any[], name: string, field: string): any | null {
    if (!name || !list || !list.length) { return null; }
    const n = ('' + name).toLowerCase().trim();
    let m = list.find((x) => ('' + (x[field] || '')).toLowerCase().trim() === n);
    if (!m) { m = list.find((x) => ('' + (x[field] || '')).toLowerCase().includes(n) || n.includes(('' + (x[field] || '')).toLowerCase())); }
    return m || null;
  }

  /** Readable prescription text fed to the AI "Patient Instructions" card. */
  get aiMedicineContext(): string {
    const rows: MedicineModal[] = (this.medicine_dss && this.medicine_dss.data) || [];
    if (!rows.length) { return ''; }
    return rows
      .filter(m => m && (m.medicineName || m.drugName))
      .map((m, i) => {
        const name = m.medicineName || m.drugName || 'Medicine';
        const dose = m.dosageCode ? `, dosage ${m.dosageCode}` : '';
        const dur = m.days ? `, ${m.days} ${m.daysUnit || 'days'}` : '';
        const site = m.site ? `, ${m.site}` : '';
        const qty = m.qty ? `, qty ${m.qty}${m.unit ? ' ' + m.unit : ''}` : '';
        const rem = m.remarks ? `, note: ${m.remarks}` : '';
        return `${i + 1}) ${name}${dose}${dur}${site}${qty}${rem}`;
      })
      .join('\n');
  }

  displayedColumns_medicine: string[] = ['medicine', 'qty', 'doasage', 'duration', 'unitQty', 'unit', 'site', 'remarks', 'Action'];
  //filteredOptions_drugs: Observable<any[]>;
  DrugControl = new FormControl();
  //filteredOptions_remarks: Observable<any[]>;
  RemarkControl = new FormControl();
  @Input() medicineModule: any;
  constructor(private MedicianService: VoiceRecognitionService,
    private dialogRef: MatDialogRef<MedicineComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private emrservice: EMRService, private opdvisitService: OpdVisitService, private dialog: MatDialog, private dashboardService: DashboardService, private authService: AuthService, private datepipe: DatePipe
  ) {

    this.MedicianService.init();
  }


  ngOnInit(): void {
    if (this.data) {
      this.isheader = this.data.isheader;
    } else {
      this.isheader = false;
    }
    this.examdetailArray = [];
    this.medicinlistarray = [];
    this.mediniceMainArray = [];
    this.dosedataArray = [];
    this.emrservice.enabledisablebtnMed = true;

    // AI Scribe — pre-fill medicines from a voice consultation
    this.emrservice.aiWorkup$.pipe(takeUntil(this.destroymedicine$)).subscribe(() => this.consumeAiMedicines());
    interval(1500).pipe(takeUntil(this.destroymedicine$)).subscribe(() => this.consumeAiMedicines());

    this.emrservice.share.pipe(takeUntil(this.destroymedicine$)).subscribe((x: any) => {

      if (x == 2) {
        this.examid = this.emrservice.examid;
        this.GetPrescriptionDetailRegId(this.opdvisitService.patientdetails.pkRegId);
      }
      if (x == 3) {
        this.examid = this.emrservice.examid;
        this.GetPrescriptionDetailRegId(this.opdvisitService.patientdetails.pkRegId);
        //  this.opdvisitService.patientDrdetaill = this.opdvisitService.patientDrdetaill.filter(item => item.pK_ExamId == this.emrservice.examid);
      }
      if (x == 22) {
        this.examid = this.emrservice.examid;
      }
    });

    // this.GetPrescriptionDetailRegId(this.opdvisitService.patientdetails.pkRegId);
    this.GetMedicineMaster(0, 0, 0,0)
    this.GetDosageMaster(0, 0, 0);
    this.medicine_dss = new MatTableDataSource(JSON.parse(JSON.stringify(this.emrservice.medicines)).slice());
    // this.drugController();
    this.viewdescbutton = false;
    this.getSite();
    this.emrservice.transferArrayMedicine.pipe(takeUntil(this.destroymedicine$)).subscribe((item: any) => {
      if (item.length > 0) {
        this.emrservice.enabledisablebtnMed = false;
        item?.forEach(element => {
          this.mediniceMainArray.push({
            "pK_TranId": 0,
            "fK_ExamId": this.examid ? this.examid : 0,
            "medicineName": element.medicineName,
            "qty": element.qty,
            "unitQty": element.unitQty ? element.unitQty : 0,
            "dosageCode": element.dosageCode,
            "days": element.days,
            "daysUnit": element.unit,
            "site": element.site,
            "remarks": element.remarks,
            "fK_DosageId": element.fK_DosageId,
            "pK_MedicineId": element.fK_MedicineId,
            "isEdit": false,
            "IsDeleted": 0
          });
        });

        this.medicine_dss = new MatTableDataSource(this.mediniceMainArray.slice());
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
    this.clearsearchTxt();
    this.emrservice.componentClicked$.subscribe(() => {
      if (!this.emrservice.enabledisablebtnMed) {
        setTimeout(() => {
          if (this.emrservice.examid > 0) {
            this.examid = this.emrservice.examid;
            this.SaveMedicine(true, 1);
          }
        }, 300);

      }
    });
  }
  ngOnDestroy(): void {
    console.log("destroy medicine");
    this.destroymedicine$.next(true);
    this.destroymedicine$.unsubscribe();
    this.mediniceMainArray = null;
    this.examdetailArray = null;
    this.medicinlistarray = null;
    this.medicine_dss.data = null;
    this.displayedColumns_medicine = null;
    this.sitelist = null;
    this.medicineselectholdData = null;
    this.emrservice.transferArrayMedicine = null;
  }
  getSite() {
    this.emrservice.getMasterSite().subscribe(data => {
      this.sitelist = [];
      this.sitelist = data;

    });
  }
  GetFindingGResultByregid(regid) {

    this.emrservice.GetFindingGResultByregid(regid, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr).pipe(takeUntil(this.destroymedicine$)).subscribe((x: any) => {
      this.examdetailArray = [];
      this.emrservice.patientEMRdetail = [];
      this.emrservice.patientEMRdetail = x;
      this.examdetailArray = this.emrservice.patientEMRdetail.filter(item => item.pK_ExamId == this.emrservice.examid);
      this.GetPrescriptionDetailRegId(this.opdvisitService.patientdetails.pkRegId);
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  // drugController() {

  //   this.medicineholdData =of(this.medicinlistarray);
  //   this.filteredOptions_drugs = this.DrugControl.valueChanges
  //   .pipe(startWith(''),
  //   switchMap(value => this._filter(value))
  //   );

  // }
  // private _filter(value: string): Observable<string[]> {
  //   if(value){ return this.medicineholdData.pipe(
  //     map(options => options.filter(option => option.medicineName.toLowerCase().includes(value.toLowerCase())))
  //   )}

  // }
  filtermedicinedata(event) {

    const finddata = this.filerdata(this.medicineselectholdData, event);
    if (finddata.length > 0) {
      this.medicinlistarray = finddata;
    } else {
      this.medicinlistarray = [];
      if (event.length >= 3) {
        if (event != null && event != '') {
          var pdata = event
        } else {
          pdata = 0;
        }
      }
      this.GetMedicineMaster(0, pdata, 'A',0);
    }
  }
  filerdata(items: any[], searchText: string) {
    return items ? items.filter(item => item.medicineName.search(new RegExp(searchText, 'i')) > -1) : [];

  }
  GetMedicineMaster(pK_MedicineId, type, searchtype,catrogyid) {
    this.emrservice.GetMedicineMaster(pK_MedicineId, type, searchtype,catrogyid).pipe(takeUntil(this.destroymedicine$)).subscribe(data => this.successMedicine(data), err => this.failed_category(err))
  }
  medicineselectholdData: any
  successMedicine(data) {
    this.medicinlistarray = [];
    this.medicineselectholdData = [];
    this.medicineselectholdData = data;
    this.medicinlistarray = data.filter(item => item.isActive == true);
    // this.drugController();
  }
  failed_category(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  GetPrescriptionDetailRegId(regid) {
    this.emrservice.GetPrescriptionDetailByRegId(regid, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr).pipe(takeUntil(this.destroymedicine$)).subscribe(
      data => this.success_allmedicine(data), err => this.failed_allmedicine(err)
    )
  }
  medicinedata: any = [];
  success_allmedicine(data) {

    this.mediniceMainArray = [];
    this.medicinedata = [];
    this.medicinedata = data;
    if (this.medicinedata.length > 0) {
      this.medicinedata.forEach(item => {
        if (item.fK_ExamId == this.examid) {
          this.mediniceMainArray.push({
            "pK_TranId": item.pK_TranId,
            "fK_ExamId": item.fK_ExamId,
            "medicineName": item.medicineName,
            "qty": item.qty,
            "unitQty": item.unitQty,
            "dosageCode": item.dosageCode,
            "days": item.days,
            "daysUnit": item.unit,
            "site": item.eye,
            "remarks": item.remarks,
            "fK_DosageId": item.fK_DosageId,
            "pK_MedicineId": item.fK_MedicineId,
            "isEdit": item.pK_TranId > 0 ? true : false,
            "IsDeleted": item.isDeleted,
          });
        }

      });

      this.medicine_dss = new MatTableDataSource(this.mediniceMainArray.slice());
    } else {
      this.medicine_dss = new MatTableDataSource(JSON.parse(JSON.stringify(this.emrservice.medicines)).slice());
    }

  }
  failed_allmedicine(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  getid(Medname: any) {
    // var val = Medname.option.value;
    var val = Medname.value;
    if (val != null) {
      let medid = this.medicinlistarray.filter(item => item.medicineName.toLowerCase() == val.toLowerCase());
      this.emrservice.medicines[0].pK_MedicineId = medid[0].pK_MedicineId;
      this.emrservice.medicines[0].medicineName = medid[0].medicineName;
    } else {
      this.emrservice.medicines[0].pK_MedicineId = 0;
      this.emrservice.medicines[0].medicineName = '';
    }
    this.stopService();
  }
  //medinice template
  OpenMediniceTemplate() {
    if (this.emrservice.medicinePermission.isAddPermission == true) {
      const dialogRef = this.dialog.open(MedicineTemplateComponent, {

        panelClass: 'full-width-dialog',
        maxWidth: '100vw !important',
        height: '90%',
        width: '90%',

      });

      dialogRef.afterClosed().pipe(takeUntil(this.destroymedicine$)).subscribe(result => {
        this.GetMedicineMaster(0, 0, 0,0);
        if (result.length > 0) {
          this.emrservice.enabledisablebtnMed = false;
          result.map(item => item.unitQty = 0);
          const rdmedicine = result.filter(item2 => !this.mediniceMainArray.some(item1 => item1.pK_MedicineId === item2.pK_MedicineId));
          this.mediniceMainArray = this.mediniceMainArray.concat(rdmedicine);

          this.medicine_dss = new MatTableDataSource(this.mediniceMainArray.slice());
        }

      });
    } else {
      this.dashboardService.openSnackBar("Add Permission Denied", "OK");
    }
  }

  GetDosageMaster(doseid, type, searchtype) {
    this.dosedataArray = [];
    this.emrservice.GetDosageMaster(doseid, type, searchtype).pipe(takeUntil(this.destroymedicine$)).subscribe(item => {
      this.dosedataArray = item;
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  // change dynamic value
  onSitechange(e: any, index: number) {
    if (e != null) {
      this.emrservice.enabledisablebtnMed = false;
      this.mediniceMainArray[index].site = e;
      this.medicine_dss = new MatTableDataSource(this.mediniceMainArray.slice());
    }
  }
  onUnitchange(e: any, index: number) {
    if (e != null) {
      this.emrservice.enabledisablebtnMed = false;
      this.mediniceMainArray[index].daysUnit = e;
      this.medicine_dss = new MatTableDataSource(this.mediniceMainArray.slice());
    }
  }
  ondaysChange(e: any, index: number) {
    if (e != null) {
      this.emrservice.enabledisablebtnMed = false;
      this.mediniceMainArray[index].days = e;
      this.medicine_dss = new MatTableDataSource(this.mediniceMainArray.slice());
    }
  }
  onUQtyChange(e: any, index: number) {
    if (e != null) {
      this.emrservice.enabledisablebtnMed = false;
      this.mediniceMainArray[index].unitQty = e;
      this.medicine_dss = new MatTableDataSource(this.mediniceMainArray.slice());
    }
  }
  onremarkschange(e: any, index: number) {
    if (e != null) {
      this.emrservice.enabledisablebtnMed = false;
      this.mediniceMainArray[index].remarks = e;
      this.medicine_dss = new MatTableDataSource(this.mediniceMainArray.slice());
    }
  }
  onQtychange(e: any, index: number) {
    if (e != null && e > 0) {
      this.emrservice.enabledisablebtnMed = false;
      this.mediniceMainArray[index].qty = e;
      this.medicine_dss = new MatTableDataSource(this.mediniceMainArray.slice());
    } else {
      this.emrservice.enabledisablebtnMed = false;
      this.mediniceMainArray[index].qty = 1;
      this.medicine_dss = new MatTableDataSource(this.mediniceMainArray.slice());
    }
  }
  onDosechange(e: any, index: number) {
    if (e != null) {
      this.emrservice.enabledisablebtnMed = false;
      let doseid = this.dosedataArray.filter(item => item.dosageCode == e);
      this.mediniceMainArray[index].fK_DosageId = doseid[0].pK_DosageId;
      this.mediniceMainArray[index].dosageCode = e;
      this.medicine_dss = new MatTableDataSource(this.mediniceMainArray.slice());
    }
  }
  checkdesc(doaseid: any) {

    if (doaseid != null) {

      let doseid = this.dosedataArray.filter(item => item.dosageCode == doaseid);
      return doseid[0]?.dosageDescription;
    } else {
      return false;
    }
  }
  changeDefault(event, type) {
    switch (type) {
      case (1): {

        this.emrservice.medicines[0].qty = event;
        break;
      }
      case (2): {

        this.emrservice.medicines[0].dosageCode = event;
        let doseid = this.dosedataArray.filter(item => item.dosageCode == event);
        this.emrservice.medicines[0].fK_DosageId = doseid[0].pK_DosageId;
        break;
      }
      case (3): {

        this.emrservice.medicines[0].days = event;
        break;
      }
      case (4): {

        this.emrservice.medicines[0].daysUnit = event;
        break;
      }
      case (5): {

        this.emrservice.medicines[0].site = event;
        break;
      }
      case (6): {

        this.emrservice.medicines[0].remarks = event;
        break;
      }
      case (7): {

        this.emrservice.medicines[0].unitQty = event;
        break;
      }
    }
  }
  // closedoctorNameModalDialog() {
  //   document.getElementById("medicineNameModal").style.display = "none";
  // }
  remarkindex: number;
  remarkpopUp(event: any, index: number, type) {
    this.remarkindex = index;
    if (type == 1) {
      this.refReasonPOpup();
      // document.getElementById("medicineNameModal").style.display = "Block";
    } else {
      if (event != 'customremark' && index != -1) {
        this.mediniceMainArray[index].remarks = event;
        this.medicine_dss = new MatTableDataSource(this.mediniceMainArray.slice());

      } else {
        this.emrservice.medicines[0].remarks = event;
      }
      // document.getElementById("medicineNameModal").style.display = "None";
    }

  }
  //delete pop up open 
  Cancelpopup(type) {
    if (type == 1) {
      if (this.emrservice.medicinePermission.isDeletePermission == true) {
        document.getElementById("medcineModal").style.display = "Block";
      } else {
        this.dashboardService.openSnackBar("Delete Permission Denied", "OK");
      }
    } else {
      document.getElementById("medcineModal").style.display = "None";
    }

  }
  onMedicinechange(e: any, index: number) {
    if (e != null) {
      this.emrservice.enabledisablebtnMed = false;
      this.mediniceMainArray[index].medicineName = e;
      this.medicine_dss = new MatTableDataSource(this.mediniceMainArray.slice());
    }
  }

  addMedicine() {
    if (this.emrservice.medicinePermission.isAddPermission == true) {
      debugger
      if (this.emrservice.medicines[0].pK_MedicineId > 0 && this.emrservice.medicines[0].qty != null && this.emrservice.medicines[0].dosageCode != undefined && this.emrservice.medicines[0].days != '' && this.emrservice.medicines[0].daysUnit != undefined && this.emrservice.medicines[0].site != '') {
        const checkdublicate = this.medicine_dss.data.filter(item => item.pK_MedicineId == this.emrservice.medicines[0].pK_MedicineId);
        if (checkdublicate.length == 0) {
          this.emrservice.enabledisablebtnMed = false;
          let rowtype = {
            "pK_TranId": 0,
            "fK_ExamId": this.examid ? this.examid : 0,
            "medicineName": this.emrservice.medicines[0].medicineName,
            "qty": this.emrservice.medicines[0].qty,
            "unitQty": this.emrservice.medicines[0].unitQty != null ? this.emrservice.medicines[0].unitQty : 0,
            "dosageCode": this.emrservice.medicines[0].dosageCode,
            "days": this.emrservice.medicines[0].days,
            "daysUnit": this.emrservice.medicines[0].daysUnit,
            "site": this.emrservice.medicines[0].site,
            "remarks": this.emrservice.medicines[0].remarks,
            "fK_DosageId": this.emrservice.medicines[0].fK_DosageId,
            "pK_MedicineId": this.emrservice.medicines[0].pK_MedicineId,
            "isEdit": false,
            "IsDeleted": 0
          }
          this.mediniceMainArray.push(rowtype);
          this.medicine_dss = new MatTableDataSource(this.mediniceMainArray.slice());
          this.emrservice.medicines[0].medicineName = null;
          this.emrservice.medicines[0].qty = null;
          this.emrservice.medicines[0].dosageCode = null;
          this.emrservice.medicines[0].days = null;
          this.emrservice.medicines[0].daysUnit = null;
          this.emrservice.medicines[0].site = null;
          this.emrservice.medicines[0].unitQty = null;
          this.emrservice.medicines[0].remarks = null;
          this.emrservice.medicines[0].fK_DosageId = 0;
          this.emrservice.medicines[0].pK_MedicineId = 0
          // this.drugController();
        } else {
          this.dashboardService.openSnackBar("Already exist in the list", "OK");
        }
      } else {
        this.dashboardService.openSnackBar("All fields are required", "OK");
      }

    } else {
      this.dashboardService.openSnackBar("Add Permission Denied", "OK");
    }
  }
  deletemedicine(row: any) {
    const index: number = this.mediniceMainArray.indexOf(row);
    if (index !== -1) {
      if (row.pK_TranId == 0) {
        this.mediniceMainArray.splice(index, 1);
        this.medicine_dss = new MatTableDataSource(this.mediniceMainArray.slice());
        //  this.deleteMedicinedaya(row, 1);
        // this.emrservice.enabledisablebtnMed=true;
      } else {
        if (Date.parse(this.datepipe.transform(new Date(this.authService.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datepipe.transform(this.emrservice.visitDate, "yyyy-MM-dd").toString()) || this.authService.Loggeduser.usertypeid == 9) {
          if (this.authService.Loggeduser.usertypeid == 6) {
            if (this.authService.Loggeduser.userid != this.opdvisitService.DoctorIdEmr) {
              this.showspinner = false;
              return this.dashboardService.openSnackBar("⁠You can not modify another's Dr workup.", "OK");
            }
          }
          if (this.emrservice.medicinePermission.isDeletePermission == true) {
            this.mediniceMainArray.splice(index, 1);
            this.medicine_dss = new MatTableDataSource(this.mediniceMainArray.slice());
            this.deleteMedicinedaya(row, 1);
          } else {
            this.dashboardService.openSnackBar("Delete Permission Denied", "OK");
          }
        } else {
          this.dashboardService.openSnackBar("You don't have permission to modify back date visit", "OK");
        }

      }

    }

  }
  deleterarray: any = [];
  deleteMedicinedaya(rowdata, type) {
    if (Date.parse(this.datepipe.transform(new Date(this.authService.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datepipe.transform(this.emrservice.visitDate, "yyyy-MM-dd").toString()) || this.authService.Loggeduser.usertypeid == 9) {
      if (this.authService.Loggeduser.usertypeid == 6) {
        if (this.authService.Loggeduser.userid != this.opdvisitService.DoctorIdEmr) {
          return this.dashboardService.openSnackBar("⁠You can not modify another's Dr workup.", "OK");
        }
      }
      if (type == 1) {
        if (rowdata.pK_TranId > 0) {
          this.deleterarray.push({
            "PK_TranId": rowdata.pK_TranId,
            "FK_ExamId": rowdata.fK_ExamId,
            "FK_MedicineId": rowdata.pK_MedicineId,
            "Qty": rowdata.qty,
            "unitQty": rowdata.unitQty,
            "FK_DosageId": rowdata.fK_DosageId,
            "Days": rowdata.days,
            "Unit": rowdata.daysUnit,
            "Eye": rowdata.site,
            "Remarks": rowdata.remarks,
            "IsEdit": true,
            "IsDeleted": 1
          });
        }

      } else {
        rowdata?.forEach(item => {
          if (item.pK_TranId > 0) {
            this.deleterarray.push({
              "PK_TranId": item.pK_TranId,
              "FK_ExamId": item.fK_ExamId,
              "FK_MedicineId": item.pK_MedicineId,
              "Qty": item.qty,
              "unitQty": item.unitQty,
              "FK_DosageId": item.fK_DosageId,
              "Days": item.days,
              "Unit": item.daysUnit,
              "Eye": item.site,
              "Remarks": item.remarks,
              "isEdit": true,
              "IsDeleted": 1
            });
          }

        })
      }
      if (this.deleterarray.length > 0) {
        this.opdvisitService.patientDrdetaill[0].pK_ExamId = this.examid;
        this.opdvisitService.patientDrdetaill[0].fK_VisitId = this.emrservice.visitid;
        this.opdvisitService.patientDrdetaill[0].fK_DoctorId = this.opdvisitService.DoctorIdEmr;
        this.opdvisitService.patientDrdetaill[0].isEdit = this.examid > 0 ? true : false;
        let payload = {

          DrExam: {
            ...this.opdvisitService.patientDrdetaill[0]

          },

          DrFinding: []
          ,
          DrDiag: [
          ],
          DrPrescrip: this.deleterarray,
          DrInvest: []
          , DrSurgery: []
        }

        this.emrservice.SaveDrwrokupData(payload).pipe(takeUntil(this.destroymedicine$)).subscribe(data => {
          this.showspinner = false;
          if (data['statusCode'] == 1) {
            this.deleterarray = [];
            if (type == 2) {
              this.mediniceMainArray = [];
            }
            if (this.mediniceMainArray.length == 0) {
              this.medicine_dss = new MatTableDataSource(JSON.parse(JSON.stringify(this.emrservice.medicines)).slice());
            }

            this.GetPrescriptionDetailRegId(this.opdvisitService.patientdetails.pkRegId);
            this.emrservice.drWorkupExamStatus(this.emrservice.visitid, this.emrservice.examid != null ? this.emrservice.examid : 0);
            this.dashboardService.openSnackBar("Record deleted successfully", "OK");
            document.getElementById("medcineModal").style.display = "None";
          } else if (data['statusCode'] == 10) {
            this.dashboardService.openSnackBar("Already exists in the list", "OK");
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        },
          err => {
            this.showspinner = false;
            this.showspinner = false;

            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
            // this.dashboardService.openSnackBar("API Failed :" + err.status + " Internal Server Error", "OK");

          });
      } else {
        if (type == 2) {
          this.mediniceMainArray = [];

        }
        if (this.mediniceMainArray.length == 0) {
          this.medicine_dss = new MatTableDataSource(this.emrservice.medicines.slice());
        }
        this.showspinner = false;
        this.dashboardService.openSnackBar("Record deleted successfully", "OK");
        document.getElementById("medcineModal").style.display = "None";
      }
    } else {
      this.showspinner = false;
      this.dashboardService.openSnackBar("You don't have permission to modify back date visit", "OK");
    }
  }
  drMedicinedata: any = [];
  SaveMedicine(event, type: any) {
    if (Date.parse(this.datepipe.transform(new Date(this.authService.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datepipe.transform(this.emrservice.visitDate, "yyyy-MM-dd").toString()) || this.authService.Loggeduser.usertypeid == 9) {
      if (this.authService.Loggeduser.usertypeid == 6) {
        if (this.authService.Loggeduser.userid != this.opdvisitService.DoctorIdEmr) {
          return this.dashboardService.openSnackBar("⁠You can not modify another's Dr workup.", "OK");
        }
      }
      this.drMedicinedata = [];
      if (this.emrservice.visitid != null && this.emrservice.visitid != undefined) {
        if (this.examid == null || this.examid == undefined) {
          this.examid = 0;
        }
        if (this.opdvisitService.patientdetails.pkRegId) {

          if (this.mediniceMainArray.length > 0) {
            if (type == 0) {
              const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
              button.setAttribute('disabled', true);
              this.showspinner = true;
            }

            this.mediniceMainArray.forEach(item => {
              this.drMedicinedata.push({
                "PK_TranId": item.pK_TranId ? item.pK_TranId : 0,
                "FK_ExamId": this.examid,
                "FK_MedicineId": item.pK_MedicineId,
                "Qty": item.qty,
                "unitQty": item.unitQty,
                "FK_DosageId": item.fK_DosageId,
                "Days": item.days,
                "Unit": item.daysUnit,
                "Eye": item.site,
                "Remarks": item.remarks,
                "IsEdit": item.pK_TranId > 0 ? true : false,
                "IsDeleted": 0

              });
            });


            this.opdvisitService.patientDrdetaill[0].pK_ExamId = this.examid;
            this.opdvisitService.patientDrdetaill[0].fK_VisitId = this.emrservice.visitid;
            this.opdvisitService.patientDrdetaill[0].fK_DoctorId = this.opdvisitService.DoctorIdEmr;
            this.opdvisitService.patientDrdetaill[0].drFristDateTimeWorkupFinish = moment(JSON.parse(sessionStorage.getItem('SessiondateTime'))).format("HH:mm:ss");
            this.opdvisitService.patientDrdetaill[0].isEdit = this.examid > 0 ? true : false;
            let payload = {

              DrExam: {
                ...this.opdvisitService.patientDrdetaill[0]

              },

              DrFinding: []
              ,
              DrDiag: [
              ],
              DrPrescrip: this.drMedicinedata,
              DrInvest: []
              , DrSurgery: []
            }

            try {
              this.emrservice.SaveDrwrokupData(payload).pipe(takeUntil(this.destroymedicine$)).subscribe(data => {
                this.showspinner = false;
                if (data['statusCode'] == 1) {
                  if (this.examid > 0) {
                    this.emrservice.savedrWorkupTrackingSatus('Modify Doctor Workup', 'true', 'DR');
                  } else {
                    this.emrservice.savedrWorkupTrackingSatus('Doctor Workup', 'false', 'DR');
                  }

                  this.examid = data['id'];
                  this.emrservice.examid = data['id'];
                  this.emrservice.enabledisablebtnMed = true;
                  // this.emrservice.content.next('2');
                  this.emrservice.GetFindingGResultByregidd(this.opdvisitService.patientdetails.pkRegId, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr, 1);
                  this.GetPrescriptionDetailRegId(this.opdvisitService.patientdetails.pkRegId);
                  this.emrservice.drWorkupExamStatus(this.emrservice.visitid, this.emrservice.examid != null ? this.emrservice.examid : 0);
                  this.dashboardService.openSnackBar("Record saved successfully", "OK");
                } else if (data['statusCode'] == 10) {
                  this.emrservice.enabledisablebtnMed = false;
                  const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
                  button.removeAttribute('disabled');
                  this.dashboardService.openSnackBar("Already exists in the list", "OK");
                } else {
                  this.emrservice.enabledisablebtnMed = false;
                  const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
                  button.removeAttribute('disabled');
                  this.dashboardService.openSnackBar("API Failed", "OK");
                }
              },
                err => {

                  this.showspinner = false;
                  this.emrservice.enabledisablebtnMed = false;
                  const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
                  button.removeAttribute('disabled');
                  if (err.status == 403) {
                    this.dashboardService.openSnackBar("You Don't have Permission", "OK");
                  }
                  else if (err.error.statusCode == 422) {
                    this.dashboardService.openSnackBar(err.error.message, "OK");
                  }
                  else {
                    this.dashboardService.openSnackBar("API Failed", "OK");
                  }


                });
            }
            catch (error) {
              this.showspinner = false;
            }
          }
          else {
            this.showspinner = false;
            this.dashboardService.openSnackBar("Please Select Medicine", "OK");
          }
        } else {
          this.showspinner = false;
          this.dashboardService.openSnackBar("Please Select Patient", "OK");
        }

      } else {
        this.showspinner = false;
        this.dashboardService.openSnackBar("Please Select Visit List", "OK");
      }
    } else {
      this.showspinner = false;
      this.dashboardService.openSnackBar("You don't have permission to modify back date visit", "OK");
    }
  }

  refReasonPOpup() {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',
      data: {
        parametertype: 'OPDMPresRemarks'
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroymedicine$)).subscribe(result => {
      if (result != 0) {
        this.emrservice.enabledisablebtnMed = false;
        this.remarkpopUp(result, this.remarkindex, 2);

      }
    });
  }


  startService() {
    this.MedicianService.MAtext = '';
    this.MedicianService.start('Medicine Name');
  }

  stopService() {
    // this.emrservice.medicines[0].medicineName = this.MedicianService.MAtext;
    this.MedicianService.stop('Medicine Name');
    if (this.MedicianService.MAtext) {
      this.filtermedicinedata(this.MedicianService.MAtext);
    }
  }
  clearsearchTxt() {
    this.MedicianService.MAtext = '';
  }
  closedialog() {
    this.dialogRef.close();
  }

  transferMedicine() {
    this.emrservice.doctorWorkupGetDischargePrescriptionDetail(this.opdvisitService.patientdetails.pkRegId).pipe(takeUntil(this.destroymedicine$)).subscribe((resmedi: any) => {
      if (resmedi.length > 0) {
        const newMedicines = [];
        resmedi.forEach((item) => {
          const exists = this.mediniceMainArray.some(
            (obj) =>
              obj.medicineName?.trim().toLowerCase() === item.medicineName?.trim().toLowerCase() &&
              obj.dosageCode?.trim().toLowerCase() === item.dosageCode?.trim().toLowerCase() &&
              obj.eye?.trim().toLowerCase() === item.eye?.trim().toLowerCase()
          );

          if (!exists) {
            newMedicines.push({
              alterNateMedicine: null,
              days: item.days,
              daysUnit: item.unit,
              dosageCode: item.dosageCode,
              fK_DosageId: item.fK_DosageId,
              fK_RouteId: item.fK_RouteId,
              fk_itemid: null,
              isDelete: null,
              isEdit: true,
              eye: item.eye,
              medicineName: item.medicineName,
              pK_MedicineId: item.fK_MedicineId,
              pK_SynchId: null,
              pK_TranId: 0,
              qty: item.qty,
              qtyUnit: item.unitQty,
              remarks: item.remarks,
              route: item.routeName,
              unitQty: item.unitQty,
            });
          }
        });

        this.mediniceMainArray.push(...newMedicines);
        this.medicine_dss.data = [...this.mediniceMainArray];
        this.emrservice.enabledisablebtnMed = false;
      } else {
        this.dashboardService.openSnackBar("No Record Found", "OK");
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode && err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  // print medicine data 
  PrintList: any = [];
  prescriptionSetting: any = [];
  getpreSetting(bachid, userid, data) {
    this.showspinner = true;
    if (this.emrservice.localStorePriscription.length == 0) {
      this.emrservice.GetPreSetting(bachid, userid, data).pipe(takeUntil(this.destroymedicine$)).subscribe(item => {
        this.prescriptionSetting = [];
        this.PrintList = [];
        this.prescriptionSetting = item;

        this.PrintList = this.prescriptionSetting.filter(x => !x.colName.startsWith("Clear"));
        if (this.prescriptionSetting.length == 0) {
          this.defualtsetdata(data);
        } else {
          let checkreporttype = this.authService.webreportConfig.filter(item => item.printOption == 'Medical Prescription' && item.printType == 'NetramReport');
          if (checkreporttype.length > 0) {
            this.getprintReport_url(this.opdvisitService.patientdetails.pkRegId);
          } else {
            this.printTimelineBill(0)
          }

        }
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
    } else {
      this.PrintList = [];
      this.PrintList = this.emrservice.localStorePriscription;
      let checkreporttype = this.authService.webreportConfig.filter(item => item.printOption == 'Medical Prescription' && item.printType == 'NetramReport');
      if (checkreporttype.length > 0) {
        this.getprintReport_url(this.opdvisitService.patientdetails.pkRegId);
      } else {
        this.printTimelineBill(0)
      }
    }
  }
  defualtsetdata(data) {
    this.emrservice.GetPreSetting(1, 1, data).pipe(takeUntil(this.destroymedicine$)).subscribe(item => {
      this.prescriptionSetting = [];
      this.PrintList = [];
      this.prescriptionSetting = item;
      this.PrintList = this.prescriptionSetting.filter(x => !x.colName.startsWith("Clear"));
      let checkreporttype = this.authService.webreportConfig.filter(item => item.printOption == 'Medical Prescription' && item.printType == 'NetramReport');
      if (checkreporttype.length > 0) {
        this.getprintReport_url(this.opdvisitService.patientdetails.pkRegId);
      } else {
        this.printTimelineBill(0)
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  printTimelineBill(type) {

    let payload = {
      "WebReportPrintMaster": {
        "module": "Doctor",

        "printOption": "Medical Prescription",
        "printType": "WebNetramReport",
        "PRINTDATE": this.datepipe.transform(this.authService.localDate, "dd-MM-yyyy"),
        "PrintTime": this.emrservice.convertTime12Hour(new Date()),
        "Pk_RegId": this.opdvisitService.patientdetails.pkRegId,
        "BILLINGCOMPANYNAME": this.authService.Loggeduser.billingcompanyname,
        "PRINTCONFIGURATIONARRAY": JSON.stringify(this.PrintList),
        "Pk_VisitId": this.emrservice.visitid,
        "Pk_ExamId": type == 0 ? this.emrservice.examid : 0,
        "VISITDATE": this.datepipe.transform(this.emrservice.visitDate, "dd-MM-yyyy"),
        "LINE1": this.emrservice.branchmansterObj.line1,
        "LINE2": this.emrservice.branchmansterObj.line2,
        "LINE3": this.emrservice.branchmansterObj.line3,
        "LINE4": this.emrservice.branchmansterObj.line4,
        "HOSPITALIMAGE": "../../../" + this.authService.loginclientlogo,
        "COMPANYIMAGE": "../../../" + this.authService.leftbottomlogosm,
        "CERTIFICATE1IMAGE": "../../../" + this.authService.nabhlogo,
        "CERTIFICATE2COMPANYIMAGE": '',
        "PrintHeaderArray": 'Y',
        "PatientRegistrationArray": 'Y',
        "VisitMasterArray": 'Y',
        'HistoryGeneralArray': 'N',
        'DoctorExaminationMasterArray': 'Y',
        'AutoRefExaminationArray': 'N',
        'HistoryDiseaseArray': 'N',
        "CounselorExaminationArray": 'N',
        "HistorySurgicalArray": 'N',
        "HistoryFamilyArray": 'N',
        "HistoryDrugAllergyArray": 'N',
        "PresentingComplaintsArray": 'N',
        "AdvisedInvestigationsArray": 'N',
        "IntraocularPressureArray": 'N',
        "OptoExaminationArray": 'N',
        "OptoTestDetailArray": 'N',
        "OptoSlitLampExaminationArray": 'N',
        "CurrentMedicationDetailArray": 'N',
        "DoctorFindingArray": 'Y',
        "DoctorInvestigationArray": 'Y',
        "DoctorDiagnosisArray": 'Y',
        "DoctorPrescriptionArray": 'Y',
        "DoctorSurgeryArray": 'Y',

      }
    }
    this.emrservice.GetWebReportPrint(payload).pipe(takeUntil(this.destroymedicine$)).subscribe((x: any) => {
      this.showspinner = false;
      if (x.length > 0) {
        let printContents, popupWin;

        printContents = x[0].printTemplate;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');

        popupWin.document.open();
        popupWin.document.write(`
  <html>
   
  <body onload="window.print()">${printContents}
  </body>
  </html>`
        );

        popupWin.document.close();
      } else {
        this.dashboardService.openSnackBar("Report Template Not Set", "OK");
      }
    }, err => {
      this.showspinner = false;
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })

  }
  getprintReport_url(patientid: number) {
   
    this.showspinner = false;
    const PrescriptionMedicine = this.opdvisitService.documentrul.filter(item => item?.propertyName == "PrescriptionMedicinePattern");
    const PageHeader = this.opdvisitService.documentrul.filter(item => item?.propertyName == "PageHeadWebReport");
    const reporturl = this.opdvisitService.documentrul.filter(item => item?.propertyName == "WebURL");
    let vDate = this.datepipe.transform(this.emrservice.visitDate, 'dd-MMM-yyyy');
    window.open(
      reporturl[0].propertyValue +
      "MedicinePrescriptionOnly.aspx?PrescriptionMedicinePattern=" +
      PrescriptionMedicine[0].propertyValue +
      "&BranchId=" +
      this.authService.Loggeduser.branchid +
      "&BillCompanyName=" +
      this.authService.Loggeduser.billingcompanyname +
      "&RegID=" +
      patientid +
      "&AgeDesc=" +
      this.opdvisitService.printpriciptionAge +
      "&VisitID=" +
      this.emrservice.visitid +
      "&VisitDate=" +
      vDate +
      "&ExamID=" +
      this.emrservice.examid +
      "&DoctorId=" +
      this.opdvisitService.DoctorIdEmr +
      "&" +
      this.PrintList[0].colName +
      "=" +
      (this.PrintList[0].colValue == true ? "Y" : "N") +
      "&PageHeadWebReport=" +
      (this.PrintList[13].colValue == true ? "Y" : "N") +
      "&PrintOPDTest=" +
      (this.PrintList[15].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[1].colName +
      "=" +
      (this.PrintList[1].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[2].colName +
      "=" +
      (this.PrintList[2].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[3].colName +
      "=" +
      (this.PrintList[3].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[4].colName +
      "=" +
      (this.PrintList[4].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[5].colName +
      "=" +
      (this.PrintList[5].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[6].colName +
      "=" +
      (this.PrintList[6].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[7].colName +
      "=" +
      (this.PrintList[7].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[8].colName +
      "=" +
      (this.PrintList[8].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[9].colName +
      "=" +
      (this.PrintList[9].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[10].colName +
      "=" +
      (this.PrintList[10].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[11].colName +
      "=" +
      (this.PrintList[11].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[12].colName +
      "=" +
      (this.PrintList[12].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[13].colName +
      "=" +
      (this.PrintList[13].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[14].colName +
      "=" +
      (this.PrintList[14].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[15].colName +
      "=" +
      (this.PrintList[15].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[16].colName +
      "=" +
      (this.PrintList[16].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[17].colName +
      "=" +
      (this.PrintList[17].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[18].colName +
      "=" +
      (this.PrintList[18].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[19].colName +
      "=" +
      (this.PrintList[19].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[20].colName +
      "=" +
      (this.PrintList[20].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[21].colName +
      "=" +
      (this.PrintList[21].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[22].colName +
      "=" +
      (this.PrintList[22].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[23].colName +
      "=" +
      (this.PrintList[23].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[24].colName +
      "=" +
      (this.PrintList[24].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[25].colName +
      "=" +
      (this.PrintList[25].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[26].colName +
      "=" +
      (this.PrintList[26].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[27].colName +
      "=" +
      (this.PrintList[27].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[28].colName +
      "=" +
      (this.PrintList[28].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[29].colName +
      "=" +
      (this.PrintList[29].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[30].colName +
      "=" +
      (this.PrintList[30].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[31].colName +
      "=" +
      (this.PrintList[31].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[32].colName +
      "=" +
      (this.PrintList[32].colValue == true ? "Y" : "N") +
      "&UserTypeId=" +
      this.authService.Loggeduser.usertypeid +
      "&LanguageId=" +
      1 +
      "&ReportHeading=Prescription"
    );

  }

}
